module.exports = __webpack_public_path__ + "img/zachestnyibiznes.9d8fe5f0.png";